import { useSelector } from 'react-redux';
import {
  getActiveSession,
  getActiveSessionStatus,
  getIsSessionActive,
} from 'domains/delegation/DelegationSession.store';
import { getUserProfileSearchStatus, getUserRights, UserRole } from 'domains/user';
import { FOUND } from 'utils';

export const useIsB2B = (): boolean => {
  const userRights = useSelector(getUserRights);
  const isDelegationActive = useSelector(getIsSessionActive);
  const delegationSessionStatus = useSelector(getActiveSessionStatus);
  const userProfileStatus = useSelector(getUserProfileSearchStatus);
  const activeSession = useSelector(getActiveSession);

  const hasB2BRights = userRights.includes(UserRole.R1) && !userRights.includes(UserRole.CONNECT_COMMANDE);

  // While delegation is active, wait until session and delegated profile are both resolved.
  // This prevents evaluating B2B against stale original-user roles during context switch.
  if (isDelegationActive) {
    if (delegationSessionStatus !== FOUND || userProfileStatus !== FOUND) {
      return false;
    }

    // Use the delegated buyer's relation-to-seller to determine B2B access.
    // Only R1 buyers (sellers acting as their own buyer account) have B2B access.
    const buyerRelation = activeSession?.delegatedBuyerRelationToSeller;
    if (buyerRelation !== undefined) {
      return buyerRelation === 'R1';
    }

    // Fallback to roles-based check if buyerRelationToSeller is not available (legacy)
    return hasB2BRights;
  }

  // When not delegated, check original user's roles
  return hasB2BRights;
};
